import { Component, HostListener } from '@angular/core';
import {AsideService, AsideState} from "../../../../core/services/aside-service/aside-service.service";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {AuthStateService} from "../../../../core/services/auth/auth-state.service";
import {User} from "../../../../models/User";
import {Router, RouterLink} from "@angular/router";
import {AuthService} from "../../../../core/services/auth/auth.service";
import {BreadcrumbService} from "../../../../core/services/breadcrumb/breadcrumb.service";
import {Breadcrumb} from "../../../../models/Breadcrumb";
import { BookFormService } from "../../../../core/services/book-form.service";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-navbar',
  standalone: true,
  imports: [
    NgIf,
    NgOptimizedImage,
    NgForOf,
    RouterLink,
    CommonModule
  ],
  templateUrl: './dashboard-navbar.component.html',
  styleUrl: './dashboard-navbar.component.css'
})
export class DashboardNavbarComponent {
  asideState!: AsideState;
  user: User | null = null;
  breadcrumbs: Breadcrumb | null = null;
  isProfessional: boolean = false;
  permissions: string[] = [];
  constructor(public asideService: AsideService,
              public authStateService: AuthStateService,
              private router: Router,
              private authService: AuthService,
              public bookFormService: BookFormService,
              private breadcrumbService: BreadcrumbService) {
      this.asideService.asideState$.subscribe({
        next: (a: AsideState) => {
          this.asideState = a;
        }
      })
    this.authStateService.currentUser.subscribe(data => {
      this.user = data;
    });
      this.breadcrumbService.breadcrumb.subscribe(data => {
        this.breadcrumbs = data;
      })
      this.isProfessional = !this.authStateService.isNotProfessional();
       this.authStateService.currentUser.subscribe(data => {
      this.permissions = data?.permissions ?? [];

    })
  }

  logOut(){
    this.authService.logOut().subscribe({
      next: value => {
        this.authStateService.setUser(null);
        this.router.navigate(['/login'])
      },error: () => {
        this.authStateService.setUser(null);
        this.router.navigate(['/login'])
      }
    })
    // TODO: LOGOUT

  }

  public resetBookForm() {
    if (this.user && this.isProfessional) {
      this.bookFormService.resetProfessional({
        registration_number: this.user.profile.name
      }, { name: this.user.profile.name, email: this.user.profile.email, phone_number: this.user.profile.phone })
    } else {
      this.bookFormService.reset(undefined);
    }
  }

  showMenu = false;

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.showMenu = !this.showMenu;
  }

  changeLang(lang: string) {
    this.showMenu = false;
  }

  logOutAndCloseMenu() {
    this.logOut();
    this.showMenu = false;
  }

  @HostListener('document:click', ['$event'])
  closeMenuOnClickOutside(event: MouseEvent) {
    const clickedInside = event.target instanceof HTMLElement && event.target.closest('.menu-container');
    if (!clickedInside) {
      this.showMenu = false;
    }
  }

}

